import React, { Component } from "react";
import Header from "Orgs/Header";
import TermsOfUseFooter from "Orgs/TermsOfUseFooter";
import SupportInfo from "Molecules/SupportInfo";
import PageHeader from "Molecules/PageHeader";
import { digitalData } from "../../../../utils/analyticsData";
import Loader from "react-loader-spinner";
import Crypto from "crypto-js/enc-utf8.js";
import base64encrypt from "crypto-js/enc-base64.js";

let captcha;

if(sessionStorage.getItem('app_info')){
captcha = JSON.parse(sessionStorage.getItem('app_info')).ONEINC_VALUE;
}
// Accounts Page test is a copy paste component of AccountsPage component that
// recieves billing account and zip code from url as props
// and calls loadAccounts that does the account validation.
// we will probably need to change this component to render loading item while the validation is occuring.
class PortalAccounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      billingAccountNumber: this.props.match.params.billing,
      zipCode: this.props.match.params.zipCode,
      error: false,
      message: "",
      supportInfo:false
    };
  }

  toggleSupportInfo = () =>{
    let si=!this.state.supportInfo;
    this.setState({
      ...this.state,
      supportInfo:si
    });
  }
  closeBox = () =>{
    this.setState({
      ...this.state,
      supportInfo:false
    });
  }
  addZero = (x, n) => {
    while (x.toString().length < n) {
      x = "0" + x;
    }
    return x;
  }
  base64Encrypt = (data) => {
		let encryptedUCode = '';
		var wordArrayUCode = Crypto.parse(data);
	    encryptedUCode = base64encrypt.stringify(wordArrayUCode);
		return encryptedUCode;
	}

  componentWillMount() {
    const d = new Date();
    let h = this.addZero(d.getUTCHours(), 2);
    let m = this.addZero(d.getUTCMinutes(), 2);
    let s = this.addZero(d.getUTCSeconds(), 2);
    let ms = this.addZero(d.getUTCMilliseconds(), 3);
    let timeStamp = h + ":" + m + ":" + s + "." + ms;
    let cCode = captcha;
    let uCode = this.base64Encrypt(cCode);
    this.props.loadAccounts(
      this.state.billingAccountNumber,
      this.state.zipCode,
      cCode,
      uCode,
      timeStamp,
      this.props.history,
      true
    );
  }

  componentDidMount() {

    global.digitalData = digitalData;
    window.addEventListener("resize", () => {
      if (window.innerWidth < 760) {
        this.closeBox();
      }
    });
  }

  render() {
    return (
      <div
        style={{
          height: "100vh",
          margin: "0",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="masthead">
        <Header toggleBox={this.toggleSupportInfo} closeBox={this.closeBox}/>
          {this.state.supportInfo && <div className="infoBox support-info-is-visible">
            <SupportInfo closeBox={this.toggleSupportInfo}/>
          </div>}
          <PageHeader
            title="Bill pay"
            subtitle="Choose the amount you&nbsp;want to&nbsp;pay for each account."
          />
        </div>
        {this.state.error && (
          <div
            style={{
              color: "#E03C31",
              fontSize: "calc(0.975rem + 0.125 * (100vw - 380px) / 644)",
              fontFamily: "Source Sans Pro, Arial, sans-serif",
              margin: "auto",
            }}
          >
            {this.state.message}
          </div>
        )}
        <main>
        {!this.state.error && (
          <div style={{margin:"auto"}} className="loading-icon">
            <Loader type="Rings" color="#000080" width="100" height="100" />
          </div>
        )}</main>
        <div style={{ marginTop: "auto", width: "100%" }}>
          <TermsOfUseFooter />
          {window.innerWidth<760 && <div className="infoBox support-info-is-hidden">
            <SupportInfo mobile={true}/>
          </div>}
        </div>
      </div>
    );
  }
}

export default PortalAccounts;



// WEBPACK FOOTER //
// ./src/components/atomic/pages/PortalAccounts/PortalAccounts.js